import { useCallback, useState } from "react"
import { Button } from "@mui/material"
import TohMuteDialog from "./TohMuteDialog"

const TohMuteControl = ({ disabled, userId }) => {
    const [open, setOpen] = useState(false)

    const handleOpen = useCallback(() => {
        setOpen(true)
    }, [])

    const handleClose = useCallback(() => {
        setOpen(false)
    }, [])

    return (
        <>
            <Button
                fullWidth
                size="small"
                color="error"
                disabled={disabled}
                onClick={handleOpen}
            >
                Mute
            </Button>
            <TohMuteDialog
                open={open}
                playerId={userId}
                onClose={handleClose}
            />
        </>
    )
}

export default TohMuteControl
